import type { StateTree } from '@makemydeal/dr-dash-types';
import type { BusinessEntity } from '../reducers/editCustomerReducer';
import { getIsContractGenerated } from './contractingSelectors';
import { getDealLifecycleStatus } from './dealLifecycleSelectors';

export const showEditCustomerSlideout = (state: StateTree) => {
    return state.editCustomerSlideout.showEditCustomer || '';
};

export const getCustomersToSync = (state: StateTree) => {
    return state.editCustomerSlideout.customersToSync;
};

export const getCreateBusinessError = (state: StateTree) => {
    return state.editCustomerSlideout.createBusinessError || '';
};

export const getCreateBusinessLoading = (state: StateTree) => {
    return state.editCustomerSlideout.createBusinessLoading;
};

export const getShowBusinessSearch = (state: StateTree): boolean => {
    return state.editCustomerSlideout.businessSearch?.show ?? false;
};

export const getBusinessSearchResults = (state: StateTree): BusinessEntity[] => {
    return state.editCustomerSlideout.businessSearch?.results ?? [];
};

export const getBusinessSearchLoading = (state: StateTree): boolean => {
    return state.editCustomerSlideout.businessSearch?.loading ?? false;
};

export const getBusinessSearchError = (state: StateTree): string | null => {
    return state.editCustomerSlideout.businessSearch?.error ?? null;
};

export const getSelectedBusinessEntityId = (state: StateTree): string | null => {
    return state.editCustomerSlideout.businessSearch?.selectedBusinessEntityId ?? null;
};

export const getAssociateBusinessLoading = (state: StateTree): boolean => {
    return state.editCustomerSlideout.businessSearch?.associateLoading ?? false;
};

export const getAssociateBusinessError = (state: StateTree): string | null => {
    return state.editCustomerSlideout.businessSearch?.associateError ?? null;
};

export const getIsDealSoldOrContracted = (state: StateTree): boolean => {
    return getDealLifecycleStatus(state) === 'Sold' || getIsContractGenerated(state);
};
